/**
 * Encapsulates `Option[Evaluation]` objects returned by the APIs.
 *
 * The non-empty objects are of the form
 *   {
 *     "score": Number
 *     "maxScore": Number,
 *     "passingFraction": Number
 *   }
 */
import _ from 'lodash';

/**
 * Construct an evaluation.
 * @param {object=} data - JSON for the evaluation. Gives you a singleton "null object" if you don't specify this.
 */
class Evaluation {
  constructor(data: $TSFixMe) {
    if (data) {
      _.extend(this, _.pick(data, 'score', 'maxScore', 'passingFraction'));
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'none' does not exist on type 'typeof Eva... Remove this comment to see the full error message
      return Evaluation.none;
    }
  }

  isDefined() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'none' does not exist on type 'typeof Eva... Remove this comment to see the full error message
    return this !== Evaluation.none;
  }

  isPassed() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'none' does not exist on type 'typeof Eva... Remove this comment to see the full error message
    if (this === Evaluation.none) {
      return undefined;
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'passingFraction' does not exist on type ... Remove this comment to see the full error message
      return this.getPercentScore() >= this.passingFraction;
    }
  }

  /**
   * This is not the same as !isPassed() because both isPassed() and isFailed() return `undefined` for the
   * "null object."
   */
  isFailed() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'none' does not exist on type 'typeof Eva... Remove this comment to see the full error message
    if (this === Evaluation.none) {
      return undefined;
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'passingFraction' does not exist on type ... Remove this comment to see the full error message
      return this.getPercentScore() < this.passingFraction;
    }
  }

  getMinimumPassingScore() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'passingFraction' does not exist on type ... Remove this comment to see the full error message
    return Math.ceil(this.passingFraction * this.maxScore);
  }

  getDisplayScore() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'score' does not exist on type 'Evaluatio... Remove this comment to see the full error message
    return this.score.toString();
  }

  getPercentScore() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'score' does not exist on type 'Evaluatio... Remove this comment to see the full error message
    return this.score / this.maxScore;
  }

  getHumanPercentScore() {
    return Math.floor(this.getPercentScore() * 100);
  }
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'none' does not exist on type 'typeof Eva... Remove this comment to see the full error message
Evaluation.none = new Evaluation({});

export default Evaluation;
